export const DESKTOP_WIDTH = 1024
export const TABLET_WIDTH = 991
export const MOBILE_WIDTH = 576
